export default __webpack_public_path__ + "static/media/Footwraps of the Harbinger.e1eb0d17.jpg";